import { Clinic } from "@doktor-se/bones-ui/dist/web-shared/types"

import { handleErrors } from "api/error/handler"
import { apiFetch } from "lib/fetch"
import { Thunk } from "lib/hooks"
import { loadClinics, loadPatientClinics } from "reducers/clinics"

interface ClinicApi {
  address: string
  clinicId: string
  name: string
  supportedQueueIds?: string[]
}

interface ClinicsApiResponse {
  count: number
  results: ClinicApi[]
}

export const clinicsFetch = (): Thunk => async dispatch => {
  try {
    const response: ClinicsApiResponse = await dispatch(apiFetch("/v2/clinic"))
    const mappedResponse = response.results.map(
      c =>
        ({
          id: c.clinicId,
          name: c.name,
          subtitle: c.address,
          supported_queue_ids: c.supportedQueueIds
        }) as Clinic
    )
    dispatch(loadClinics(mappedResponse))
  } catch (error: any) {
    dispatch(handleErrors({ error }))
  }
}

export const fetchPatientsClinics =
  (patientId: string, profileId?: string): Thunk =>
  async dispatch => {
    dispatch(loadPatientClinics([]))
    const response = await dispatch(
      apiFetch(`/patients/${patientId}/clinics${profileId ? `?profileId=${profileId}` : ""}`)
    )
    dispatch(loadPatientClinics(response))
  }

export const uploadClinicFile =
  (file: File): Thunk<Promise<boolean>> =>
  async (dispatch, getState) => {
    if (!file) {
      return false
    }

    const token = getState().auth?.accessToken
    if (!token) {
      dispatch(handleErrors({ error: new Error("No access token available") }))
      return false
    }

    try {
      const response = await dispatch(
        apiFetch(`/upload/listing`, {
          method: "POST",
          loader: "FILE UPLOAD",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fileName: file.name })
        })
      )

      const presignedUrl = response.url

      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        //loader: "FILE UPLOAD",
        headers: {
          "Content-Type": file.type
        },
        body: file
      })

      if (uploadResponse.ok) {
        return true
      } else {
        dispatch(handleErrors({ error: new Error("Upload to S3 failed") }))
        return false
      }
    } catch (error: any) {
      dispatch(handleErrors({ error, customContext: `Creating pre-signed URL Failed` }))
      return false
    }
  }
